<template>
  <div>
    <dv-water-level-pond :key="refreshFlagKey" :config="config" :style="{width:width+'px',height:height+'px'}" @click="clickHandler"/>
  </div>
</template>

<script setup>
import {getDataJson, pollingRefresh,hasNonEmptyValues,hasProperty} from "@/utils/refresh-cpt-data";
import {reactive, watch, computed} from "vue";
import {setObj} from "@/utils/object-method";

const props = defineProps({
  width:Number,
  height:Number,
  option:Object,
  components:Array,
  current: Object
})
 // 新增属性兼容旧代码
 const attr = props.option.attribute
 if (!attr.globalDataReload) attr.globalDataReload = [0]

 let dataReload = computed(() => props.option.attribute.globalDataReload || [0])
 watch(props.current.cptShow,(val)=>{
    if (val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
  watch(props.option.attribute.hideCompInTabw,(val)=>{
    if (!val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })

// watch(() => props.option.attribute, () => {
//   processData(props.option.cptDataForm,newData,jsFunFlag);
//   // loadData(props.option.cptDataForm);
// },{deep:true})
watch(() => [props.width,props.height], () => {
  refreshFlagKey = require('uuid').v1();
})

let uuid = require('uuid').v1();
let refreshFlagKey = require('uuid').v1();
let config = reactive({});
let newData = null;
let jsFunFlag = false;
const emit = defineEmits(['clickHandler'])

function refreshCptData(cptDataForm = props.option.cptDataForm){
  pollingRefresh(uuid, cptDataForm, () => loadData(cptDataForm),
  props.components);
  refreshFlagKey = require('uuid').v1();
}
function loadData(cptDataForm){
  getDataJson(cptDataForm,'',(res)=> {
    newData = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
    jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
    processData(cptDataForm,newData,jsFunFlag)
  })
}
function processData(cptDataForm,res,jsFunFlag) {
    let cptData;
      // 第一层判断 如果选择数据集
    if(cptDataForm.dataSource == '4') {
      // 第二层判断 ，如果没有配转换脚本
      if(jsFunFlag) { // 没有全部配置映射字段
          if(hasNonEmptyValues(props.option.attribute.cptTableData)) {
          const dataKey = props.option.attribute.cptTableData;
        // 创建一个新的数组用于存储结果
          let dynamicKey = dataKey[0].value; 
          let newres = [res[0][dynamicKey]];
          cptData = newres;
        }
        } else { // 如果配置了转换脚本
          cptData = res;
        }
    } else { // 不是数据集类型，是静态数据
         cptData = res;
    } 
    setObj(config, JSON.parse(JSON.stringify(props.option.attribute)))
    config.data = cptData;
}
function clickHandler(){
  emit("clickHandler",props.option.interaction)
}

if (dataReload.value.includes(0)) {
  refreshCptData();
}

defineExpose({refreshCptData})
</script>

<style scoped>

</style>
